// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-container {
  display: flex;
  flex-direction: row;
  max-height: 200px;
}

.top-left-summ {
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  margin-top: 22px;
  border: 1px solid rgba(116, 123, 169, 1);
  /* background-color: rgba(255, 255, 255, 0.05); */
  width: 100%;
  border-radius: 10px;
}

.barchart {
  width: 100%;
}

.left-sum {
  display: flex;
  flex-direction: column;

}

.top-icon-sum {
  text-align: right;
  padding-left: 20px;
}

.top-sum {
  width: 3%;
  margin-left: 5px;

}

.right-sum {

  flex-direction: column;

}

.business-Heading-summ {
  color: white;
  font-family: 'Graphik', sans-serif;
  font-size: 15px;
  padding-left: 15px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
}

.key-table td {
  padding: 9px;
  border: 0.5px solid rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
  width: 600px;
  text-align: left;
  color: white;
  font-size: 11px;
  
}

.bottom-left-summ {
  border: 1px solid rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  margin-top: 20px;

}

.table.key-table {
  border: 2px solid rgba(116, 123, 169, 1);
  background-color: rgba(255, 255, 255, 0.05);
  width: 100%;
  border-radius: 10px;
}

.top-right-summ {
  display: flex;
  flex-direction: row;
   background-color: rgba(255, 255, 255, 0.05);
  width: 500px;
  min-height: 180px;
  border-radius: 10px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
}

.img-sum {
  width: 55%;

}

.bottom-right-summ {
  border-radius: 10px;
  width: 500px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(116, 123, 169, 1);
  margin: 20px;
}

/* .table {
  border-collapse: collapse;
  width: 100%;
}

.table th,
.table td {
  border: 1px solid #ddd;
  width: 200px;
  padding: 8px;
  text-align: left;
} */

.bar-chart {


  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

.pie-chart {


  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
}

.detect-sum {
  font-size: 13px;
  padding-top: 30px;
 
  padding-right: 10px;
  font-weight: 400;
  font-family: 'Graphik', sans-serif;
  color: white;
}

.type-sum {
  font-size: 13px;
  color: white;
  font-family: 'Graphik', sans-serif;
  padding-top: 20px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Summary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,iDAAiD;EACjD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;;AAElB;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;GAClB,2CAA2C;EAC5C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,wCAAwC;EACxC,YAAY;AACd;;AAEA;;;;;;;;;;;GAWG;;AAEH;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".summary-container {\n  display: flex;\n  flex-direction: row;\n  max-height: 200px;\n}\n\n.top-left-summ {\n  display: flex;\n  flex-direction: row;\n  border-radius: 10px;\n  margin-top: 22px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  /* background-color: rgba(255, 255, 255, 0.05); */\n  width: 100%;\n  border-radius: 10px;\n}\n\n.barchart {\n  width: 100%;\n}\n\n.left-sum {\n  display: flex;\n  flex-direction: column;\n\n}\n\n.top-icon-sum {\n  text-align: right;\n  padding-left: 20px;\n}\n\n.top-sum {\n  width: 3%;\n  margin-left: 5px;\n\n}\n\n.right-sum {\n\n  flex-direction: column;\n\n}\n\n.business-Heading-summ {\n  color: white;\n  font-family: 'Graphik', sans-serif;\n  font-size: 15px;\n  padding-left: 15px;\n  font-weight: 500;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.key-table td {\n  padding: 9px;\n  border: 0.5px solid rgba(116, 123, 169, 1);\n  background-color: rgba(255, 255, 255, 0.05);\n  width: 600px;\n  text-align: left;\n  color: white;\n  font-size: 11px;\n  \n}\n\n.bottom-left-summ {\n  border: 1px solid rgba(116, 123, 169, 1);\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  margin-top: 20px;\n\n}\n\n.table.key-table {\n  border: 2px solid rgba(116, 123, 169, 1);\n  background-color: rgba(255, 255, 255, 0.05);\n  width: 100%;\n  border-radius: 10px;\n}\n\n.top-right-summ {\n  display: flex;\n  flex-direction: row;\n   background-color: rgba(255, 255, 255, 0.05);\n  width: 500px;\n  min-height: 180px;\n  border-radius: 10px;\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n  margin-top: 20px;\n  padding: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n}\n\n.img-sum {\n  width: 55%;\n\n}\n\n.bottom-right-summ {\n  border-radius: 10px;\n  width: 500px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(116, 123, 169, 1);\n  margin: 20px;\n}\n\n/* .table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ddd;\n  width: 200px;\n  padding: 8px;\n  text-align: left;\n} */\n\n.bar-chart {\n\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n}\n\n.pie-chart {\n\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n}\n\n.detect-sum {\n  font-size: 13px;\n  padding-top: 30px;\n \n  padding-right: 10px;\n  font-weight: 400;\n  font-family: 'Graphik', sans-serif;\n  color: white;\n}\n\n.type-sum {\n  font-size: 13px;\n  color: white;\n  font-family: 'Graphik', sans-serif;\n  padding-top: 20px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
